module.exports = __webpack_public_path__ + "static/media/adventurer-gold-yeti.8149ab74.png";